import {
    faArrowDownRight,
    faArrowRight,
    faArrowUpRight,
    faArrowUpRightFromSquare,
    faArrowRightFromBracket,
    faArrowTrendUp,
    faArrowTrendDown,
    faArrowUpFromSquare,
    faAward,
    faBars,
    faBoxOpen,
    faCalendar,
    faCalendarClock,
    faCamera,
    faCartShopping,
    faChartColumn,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleCheck,
    faCircleExclamation,
    faCircleInfo,
    faClock,
    faDna,
    faDownload,
    faDroplet,
    faEnvelope,
    faFlask,
    faGear,
    faGrid,
    faHouse,
    faLink,
    faList,
    faLock,
    faMagnifyingGlass,
    faMinus,
    faPencil,
    faPhone,
    faPlus,
    faRepeat,
    faShieldCheck,
    faSparkles,
    faSpinner,
    faStethoscope,
    faTag,
    faTrashCan,
    faTriangleExclamation,
    faUser,
    faVial,
    faVialCircleCheck,
    faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
    faStar,
    faChevronUp as faChevronUpSolid,
    faChevronDown as faChevronDownSolid,
    faMinus as faMinusSolid,
    faCheck as faCheckSolid,
    faArrowUpRight as faArrowUpRightSolid,
    faArrowDownRight as faArrowDownRightSolid,
    faArrowTrendUp as faArrowTrendUpSolid,
    faArrowTrendDown as faArrowTrendDownSolid,
} from '@fortawesome/pro-solid-svg-icons';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';

export const ICONS = {
    'arrow-down-right': faArrowDownRight,
    'arrow-right': faArrowRight,
    'arrow-right-from-bracket': faArrowRightFromBracket,
    'arrow-up-right': faArrowUpRight,
    'arrow-up-right-from-square': faArrowUpRightFromSquare,
    'arrow-trend-up': faArrowTrendUp,
    'arrow-trend-down': faArrowTrendDown,
    'arrow-up-from-square': faArrowUpFromSquare,
    award: faAward,
    bars: faBars,
    'box-open': faBoxOpen,
    calendar: faCalendar,
    'calendar-clock': faCalendarClock,
    camera: faCamera,
    'cart-shopping': faCartShopping,
    'chart-column': faChartColumn,
    check: faCheck,
    'chevron-down': faChevronDown,
    'chevron-left': faChevronLeft,
    'chevron-right': faChevronRight,
    'chevron-up': faChevronUp,
    circle: faCircle,
    'circle-check': faCircleCheck,
    'circle-exclamation': faCircleExclamation,
    'circle-info': faCircleInfo,
    clock: faClock,
    dna: faDna,
    download: faDownload,
    droplet: faDroplet,
    envelope: faEnvelope,
    flask: faFlask,
    gear: faGear,
    grid: faGrid,
    house: faHouse,
    link: faLink,
    list: faList,
    lock: faLock,
    'magnifying-glass': faMagnifyingGlass,
    minus: faMinus,
    pencil: faPencil,
    phone: faPhone,
    plus: faPlus,
    repeat: faRepeat,
    'shield-check': faShieldCheck,
    sparkles: faSparkles,
    spinner: faSpinner,
    star: faStar,
    'chevron-up-solid': faChevronUpSolid,
    'chevron-down-solid': faChevronDownSolid,
    'minus-solid': faMinusSolid,
    'check-solid': faCheckSolid,
    'arrow-up-right-solid': faArrowUpRightSolid,
    'arrow-down-right-solid': faArrowDownRightSolid,
    'arrow-trend-up-solid': faArrowTrendUpSolid,
    'arrow-trend-down-solid': faArrowTrendDownSolid,
    stethoscope: faStethoscope,
    tag: faTag,
    'trash-can': faTrashCan,
    'triangle-exclamation': faTriangleExclamation,
    user: faUser,
    vial: faVial,
    'vial-circle-check': faVialCircleCheck,
    xmark: faXmark,
} satisfies Record<string, IconDefinition>;

export type IconName = keyof typeof ICONS;
